import React, { useRef, useState, useMemo, useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import DataGridComponent from '../../common/DataGridComponent/DataGridComponent';
import Spinner2 from "../../common/Spinner/Spinner2";
import commonApiService from '../../../../shared/common-utilities/services/commonApiService.jsx';
import { getSubcontractors, fetchSavedView, baseUrl  } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import { Button, Grid } from '@mui/material';
import ModalComponent from '../../common/Modal/ModalComponent.js';
import AlertComponent from '../../../../shared/common-utilities/common/AlertComponent.jsx';
import ActionButton from '../../../../shared/common-utilities/common/ActionButton.jsx';
import ResourceDetails from '../../../../shared/common-utilities/common/ResourceDetails/ResourceDetails';
import WindowComponent from '../../common/Window/WindowComponent.jsx';
import i18_en from '../../../../jsonStore/i18_en.json';
import { MessageComponent, RenderActionButtons } from '../../../../shared/common-utilities/common/DeleteConfirmationComponent.jsx';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService.jsx';

const entity = "subcontractor";
let entityNameFor = "subcontractor";
const odataApiName = "subcontractors";
let odataApiNameFor = "subcontractors";
let service = getSetDataService();
let dataService = dataStorageService();
let apiService = commonApiService();
const dataRelatedAction = ['Filter', 'View Columns', 'Settings', 'Refresh', 'New Window'];
let gridSelectedValues = {};
//#region SortData start

const SubContractor = (props) => {
  //#region Reference
  const subContractorGrid = useRef(null);
  //#endregion Reference

  //#region Hook Selctor
  //#endregion Hook Selctor


  const SubContractorDataItemKey = "id";
  const initialSort = service.initialSort[entity];

  //#region States - Get set variables
  const [tempSubContractorData, setTempSubContractorData] = useState([]);
  const [subContractorGridColumnList, setSubContractorGridColumnList] = React.useState(null);
  const [tempSubContractorGridColumnList, setTempSubContractorGridColumnList] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isSubConractor, setIsSubConractor] = useState(true);
  const [loadedGridData, setLoadedGridData] = useState(tempSubContractorData);
  const [myGridData, setmyGridData] = React.useState([]);
  const [loadSelectionValue, setloadSelectionValue] = useState(100);
  const [totalData, setTotalData] = useState();
  const userID = localStorage.getItem('userID');
  
  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const [paramsData, setParamsData] = useState(null);
  let [initialFilter, setInitialFilter] = useState([]);
  const [nextDataUrl, setNextDataUrl] = useState(null);
  const [subContractorData,setSubContractorData] = useState({});
  const [initialSaveViewData, setInitialSaveViewData] = useState([]);
  const [initialFetchReadLinkData, setInitialFetchReadLinkData] = useState(null);
  const [subContractResource,setSubContractResource] = useState({});
  const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isResourceLoad, setIsResourceLoad] = useState(false);
  const [changeToChildSC, setChangeToChildSC] = useState(null);
  const [isApiCallRequired, setIsApiCallRequired] = useState(true);
  const [openConfirmationModal, setopenConfirmationModal] = useState(false);
  const [commonPopupParameters, setCommonPopupParameters] = React.useState({});
  const [errorMessage, setErrorMessage] = useState(null);
  const [canExecute, setCanExecute] = useState([]);

  const subContractorDetails = [
    { label: 'Sub Contractor Code', value: subContractResource[0]?.codeSubcontractor },
    { label: 'Name', value: subContractResource[0]?.name },
    { label: 'City', value: subContractResource[0]?.city },
  ];
  const subContractorFilterComponents = [];
  const metaData = JSON.parse(dataService.getLocalStorageData("metaData"))

  //#endregion States

  //#region Hooks  

  useEffect(() => {
    // setIsLoading(true);

    setIsApiLoaded(true);
    odataApiNameFor = odataApiName;
    entityNameFor = entity;
    if (props?.gridFlagVal) {
      odataApiNameFor += props?.gridFlagVal;
      entityNameFor += props?.gridFlagVal;
    }
    setTimeout(()=>{
      setGridColumns(entity);
    },100)

    let tempFilterData = [];
    setInitialFilter(tempFilterData);
  }, []);

  const setGridColumns = (entityName) => {
    const columnList = localStorage.getItem(entityNameFor + 'ColumnList');
    if (!_.isNil(columnList)) {
      setSubContractorGridColumnList(JSON.parse(columnList));
      getColList(JSON.parse(columnList));
      return true;
    }

    if(!_.isNil(metaData) || metaData !== "undefined") {
      service.entityDefinitions(metaData, entityName).then((tempFieldList) => {
        localStorage.setItem(entityNameFor + 'ColumnList', JSON.stringify(tempFieldList));
        setSubContractorGridColumnList(tempFieldList);
        getColList(tempFieldList);
      })
    }
  }

  const getDefaultColList = (dcolsStringSC, gridcolumns) => {
    const dColsSC = JSON.parse(localStorage.getItem("defaultColumnSetting"));
    if (!_.isNil(dcolsStringSC) && dcolsStringSC != "undefined" ) {
      const defaultColumnListSC = gridcolumns?.filter(item => {
        return dColsSC[entity]?.split("~").includes(item.field);
      });
      if (defaultColumnListSC.length == 0) {
        localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
        setTempSubContractorGridColumnList(gridcolumns);
      } else {
        const sortedArr = _.sortBy(defaultColumnListSC, function (item) { return dColsSC[entity]?.split("~").indexOf(item.field) });
        localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(sortedArr));
        setTempSubContractorGridColumnList(sortedArr);

        const arr1 = sortedArr;
        const arr2 = gridcolumns.filter(e => !sortedArr.map(x => x.field).includes(e.field));
        const newsortedArr = _.concat(arr1, arr2);
        setSubContractorGridColumnList(newsortedArr);
      }
    } else {
      localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
      setTempSubContractorGridColumnList(gridcolumns);
    }
  }

  const getColList = (gridcolumns) => {
    const scUrl = `${fetchSavedView}?$filter=(title eq '${odataApiNameFor}' and userID eq '${userID}')`;
    const dcolsStringSC = localStorage.getItem("defaultColumnSetting");
    apiService.get(scUrl).then(savedViewRes => {
      if (savedViewRes?.value?.length > 0) {
        apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"], null, null, null, null, savedViewRes.value[0]["@odata.etag"]).then(readResSC => {
          if (readResSC !== undefined && readResSC !== null) {
            setInitialSaveViewData(savedViewRes.value);
            setInitialFetchReadLinkData(readResSC);
            const defaultViewExist = readResSC[odataApiNameFor]?.savedViews?.filter(item => item.defaultView);
            setCanExecute(defaultViewExist);
            if (defaultViewExist?.length > 0 && defaultViewExist?.[0]?.subviews?.length > 0) {
              const favFilterExist = defaultViewExist[0]?.subviews?.filter(subView => subView.isDefaultFilter);
              if (favFilterExist?.length > 0) {
                setTempSubContractorGridColumnList(defaultViewExist[0].columns);
              }
            } else if (readResSC[odataApiNameFor]?.columns?.length !== 0) {
              localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(readResSC[odataApiNameFor]?.columns));
              setTempSubContractorGridColumnList(readResSC[odataApiNameFor]?.columns);
            } else {
              getDefaultColList(dcolsStringSC, gridcolumns);
            }
          }
        })
      } else {
        getDefaultColList(dcolsStringSC, gridcolumns);
      }

      setIsLoading(false);
    });
  }

  useEffect((e) => {
    if (!_.isNil(paramsData) && isApiCallRequired) {
      updateSendApi(loadSelectionValue);
    } else {
      setIsApiCallRequired(true);
    }
  }, [paramsData]);

  useEffect((e) => {
    if (!_.isNil(tempSubContractorGridColumnList)) {
      setNextDataUrl(null);
      updateSendApi(loadSelectionValue);
    }
  }, [tempSubContractorGridColumnList]);

  useEffect(()=>{
    if (!_.isNil(props.resourceData)) {
      const url = `${baseUrl}/subcontractors?&$filter=(codeSubcontractor eq '${props?.resourceData}')`;
      apiService.get(url).then(res => {
        if (res !== null && res !== undefined) {
          setSubContractResource(res.value);
          setIsResourceLoad(true);
        }
      })
    }
  },[])

  // --- API's Call START ---
  
  const sendApi = (val, size) => {
    let filter = paramsData?.filter ? '$filter=(' + paramsData?.filter + ')' : null;
    let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
    if (canExecute?.length > 0) {
      return;
    }
    if (tempSubContractorGridColumnList !== null && tempSubContractorGridColumnList !== undefined && tempSubContractorGridColumnList?.length > 0) {
      setIsLoading(true);
      const params = '&' + filter + '&' + orderby + '&$count=true';
      const columns = tempSubContractorGridColumnList?.map(item => item.field);
      const mandatroyEntity = JSON.parse(localStorage.mandatoryColumnList).find(e => e.entity == odataApiName);
      if (!_.isNull(mandatroyEntity)) {
        let splitedColums = mandatroyEntity.mandatoryColumns.split("~");
        splitedColums.forEach(element => {
          if (!columns.includes(element)) {
            columns.push(element)
          }
        });
      }

      const selectFields = `&$select=${columns}`;
      const oDataNextLink = val == 'Scroll' ? nextDataUrl : null;
      apiService.get(getSubcontractors, params, `${selectFields}`, oDataNextLink, size, null).then(response => {
        if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
          if (response?.error?.message?.includes('$orderby')) {
            const sortToRemoveSC = response.error.message.split("'")[1];
            setChangeToChildSC({ type: "sort", value: sortToRemoveSC });
          } else if (response?.error?.code == "Application_FilterErrorException") {
            const filterToRemoveSC = response.error.message.split("'")[1];
            setChangeToChildSC({ type: "filter", value: filterToRemoveSC });
          }
        } else {
          if (response.value) {
            setTotalData(response["@odata.count"]);
            let tempData = [];
            if (val == 'Scroll' && tempSubContractorData !== null && tempSubContractorData !== undefined && tempSubContractorData.length > 0) {
              tempSubContractorData.forEach(tempContractor => {
                tempData.push(tempContractor);
              });
              response.value.map(temp => {
                tempData.push(temp)
              })
            }
            // Update the data based on the response
            else {
              tempData = response.value;
            }

            tempData = service.setColorCodeAndDate(tempData, subContractorGridColumnList);
            setIsApiLoaded(true);
            if (response['@odata.nextLink'] !== null && response['@odata.nextLink'] !== undefined) {
              setNextDataUrl(response['@odata.nextLink']);
            }

            setmyGridData(tempData);
            setLoadedGridData(tempData);
            setTempSubContractorData(tempData);
          }
        }
      })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
          if (props?.sendDataToParent) {
            props.sendDataToParent(odataApiName);
          }
        });
    } else {
      setIsLoading(false);
    }
  }

  const updateSendApi = useMemo(() => {
    return _.debounce((size) => {
      sendApi(null, size);
    }, 250);
  }, [sendApi]);
  
  // --- API's Call END ---

  //#endregion Hooks

  const childStateHandler = (value, flag) => {
    if (flag === 'showGridHeader') {
      setIsSubConractor(value);
    } else if (flag === 'getData') {
      setNextDataUrl(null);
      setParamsData({ ...paramsData, filter: value.filter, orderby: value.orderby });
      setIsApiCallRequired(value.isApiCall);
      setTempSubContractorGridColumnList(value.columns);
      setCanExecute([]);
    } else if (flag === 'refresh') {
      sendApi(null, loadSelectionValue);
    } else if (flag === 'selectedValues') {
      gridSelectedValues = value;
    } else if (flag === 'dataItem') {
      setSubContractorData(value); 
    } else if (flag === 'columnsVisible') {
      setTempSubContractorGridColumnList(value);
    }
  }

  const closePopup = () => {
    props.onClose();
  }

  const onOkClick = () => {
    let transferdataId = Object.entries(gridSelectedValues).filter(([key, value]) => value === true).map(([key]) => key);
    if (transferdataId.length === 0) {
      setErrorSnackbarMessage('Please select Subcontractor');
      setErrorSnackbarOpen(true);
      return;
    }
    props?.addResourceApi(subContractorData);
    // props.onClose();
  }
  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorSnackbarOpen(false);
  };

  const deAllocateResource = () => {
    props?.addResourceApi({codeSubcontractor:""});
  }
  
  const onLoadSelectionChange = (e) => {
    let value = e.value;
    setloadSelectionValue(value);
    sendApi(null, value);
  }

  const setErrorParameterAndMessage = (errMsg) => {
    setCommonPopupParameters({
      title: 'Error'
    });
    setErrorMessage(errMsg);
    setopenConfirmationModal(true);
  }

  const closeConfirmationModal = () => {
    setopenConfirmationModal(false);
  }

  return (
    <>
      {isLoading ? (<Spinner2 isAll={loadSelectionValue} />) : (<></>)}
      <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }} id={odataApiName}>

        <AlertComponent isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose} />
        {
          props.resourceData != null && isResourceLoad && (
            <>
            {
              subContractResource.length > 0 ? (
                <>
                  <ResourceDetails details={subContractorDetails} onDeallocate={() => setIsDeleteDialogOpen(true)} />
                </>
              ) : (
                <Typography color="#ce0000" variant="body2" sx={{fontWeight:'bold',paddingBottom:'7px',textAlign:'center'}}> Allocated SubContractor ({props?.resourceData}) doesn't exists!</Typography>
              )}
            </>
          )
        }
        {isSubConractor && <Box className="headBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Subcontractor</Typography>
        </Box>}
        <Grid container sx={{ marginTop: 0 }}  >
          <Grid item={true} xs component={Card} elevation={0} pl={0} sx={{ flexGrow: 1 }} className='grid-movement'>
            {isApiLoaded && <DataGridComponent
              {...props}
              gridRef={subContractorGrid}
              gridFlagVal={odataApiName}
              gridFlagValFor={odataApiNameFor}
              gridStyle={{ maxHeight: 'calc(100%)', height: '100%', minHeight: '650px' }}
              entity={entity}
              gridNewData={myGridData}
              loadedGridData={loadedGridData}
              tempGridData={tempSubContractorData}
              gridColumnList={subContractorGridColumnList ? subContractorGridColumnList : []}
              gridTempColumnList={tempSubContractorGridColumnList ? tempSubContractorGridColumnList : []}
              isItemVisible={true}
              gridSort={initialSort}
              gridInitialFilter={initialFilter}
              isShowGridHeader={isSubConractor}
              griddDtaItemKey={SubContractorDataItemKey}
              gridDraggable={false}
              sendDataToParent={childStateHandler}
              gridDataAction={dataRelatedAction}
              gridFilterComponents={subContractorFilterComponents}
              onLoadSelectionChange={onLoadSelectionChange}
              loadSelectionValue={loadSelectionValue}
              gridtotalData={totalData}
              initialSaveViewData={initialSaveViewData}
              initialFetchReadLinkData={initialFetchReadLinkData}
              selectableMode={"single"}
              changeToChild={changeToChildSC}
            />}
          </Grid>
        </Grid>
      </Grid>
      {isDeleteDialogOpen && <WindowComponent title={i18_en.confirmDeallocateRes} visible={isDeleteDialogOpen} initialWidth={400} initialHeight={200} minWidth={400} minHeight={200} onClose={() => setIsDeleteDialogOpen(false)} dataComponent={MessageComponent} actionButtons={<RenderActionButtons onClose={() => setIsDeleteDialogOpen(false)} onConfirm={deAllocateResource}/>} resizable={false} minimizeButton={() => { return null }} maximizeButton={() => { return null }} doubleClickStageChange={false}/>}
      {
        props?.openAddColumnModal && (
          <ActionButton onOkClick={onOkClick} closePopup={closePopup}/>
        )
      }
      <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModal} />
    </>
  )
};

export default SubContractor;